var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v("Nicht gefunden")]),_c('v-card-text',[_vm._v(" Die von dir aufgerufene Seite konnte nicht gefunden werden. ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }